import { ClientContactInfo } from './models/clientContactModel';
import {
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Grid,
  GridItem,
  Input,
} from '@chakra-ui/react';
import { Controller } from 'react-hook-form';
import { FieldErrors, Control } from 'react-hook-form/dist/types/form';
import { Contact } from '@ssar-app/domain';

interface ContactDetailsProps {
  errors?: FieldErrors<ClientContactInfo>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  control: Control<any>;
  model: Partial<ClientContactInfo> | undefined;
  onChange?: (contact: Contact) => void;
  isReadOnly?: boolean;
}

export const ContactDetails = (props: ContactDetailsProps) => {
  const { errors, control, model, isReadOnly } = props;

  return (
    <Flex flexDir='column' gap={6} ml={40}>
      <FormControl isInvalid={!!errors?.clientName}>
        <Grid templateColumns='repeat(4,1fr)'>
          <GridItem justifyContent='end' display='flex'>
            <FormLabel fontSize='md' htmlFor={`clientName`} mb={0} mr={2}>
              Client Name :
            </FormLabel>
          </GridItem>
          <GridItem colSpan={3}>
            <Controller
              control={control}
              defaultValue={model?.clientName || ''}
              name={`clientName`}
              render={({ onChange, value }) => {
                return (
                  <>
                    {isReadOnly && <label>{value}</label>}
                    {!isReadOnly && (
                      <Input
                        defaultValue={value}
                        onChange={(e) => {
                          onChange(e.target.value);
                        }}
                        readOnly={isReadOnly}
                        w={'full'}
                        spellCheck={false}
                      />
                    )}
                  </>
                );
              }}
            />
            <FormErrorMessage>{errors?.clientName?.message}</FormErrorMessage>
          </GridItem>
        </Grid>
      </FormControl>
      <FormControl isInvalid={!!errors?.clientUserName}>
        <Grid templateColumns='repeat(4,1fr)'>
          <GridItem justifyContent='end' display='flex'>
            <FormLabel fontSize='md' htmlFor={`clientUserName`} mb={0} mr={2}>
              User Name :
            </FormLabel>
          </GridItem>
          <GridItem colSpan={3}>
            <Controller
              control={control}
              defaultValue={model?.clientUserName || ''}
              name={`clientUserName`}
              render={({ onChange, value }) => {
                return (
                  <>
                    {isReadOnly && <label>{value}</label>}
                    {!isReadOnly && (
                      <Input
                        defaultValue={value}
                        onChange={(e) => {
                          onChange(e.target.value);
                        }}
                        readOnly={isReadOnly}
                        w={'full'}
                        spellCheck={false}
                      />
                    )}
                  </>
                );
              }}
            />
            <FormErrorMessage>
              {errors?.clientUserName?.message}
            </FormErrorMessage>
          </GridItem>
        </Grid>
      </FormControl>
      <FormControl isInvalid={!!errors?.clientUserEmail}>
        <Grid templateColumns='repeat(4,1fr)'>
          <GridItem justifyContent='end' display='flex'>
            <FormLabel fontSize='md' htmlFor={`clientUserEmail`} mb={0} mr={2}>
              Email :
            </FormLabel>
          </GridItem>
          <GridItem colSpan={3}>
            <Controller
              control={control}
              defaultValue={model?.clientUserEmail || ''}
              name={`clientUserEmail`}
              render={({ onChange, value }) => {
                return (
                  <>
                    {isReadOnly && <label>{value}</label>}
                    {!isReadOnly && (
                      <Input
                        defaultValue={value}
                        onChange={(e) => {
                          onChange(e.target.value);
                        }}
                        readOnly={isReadOnly}
                        w={'full'}
                        spellCheck={false}
                      />
                    )}
                  </>
                );
              }}
            />
            <FormErrorMessage>
              {errors?.clientUserEmail?.message}
            </FormErrorMessage>
          </GridItem>
        </Grid>
      </FormControl>
    </Flex>
  );
};
